import { redactServerMessage } from './redact-server-message'

export type ServerErrorBody = Record<string, unknown>

export type ServerErrorCopy = string | ((body: ServerErrorBody) => string)

export const SERVER_ERROR_COPY: Record<string, ServerErrorCopy> = {
  NOT_SUPPORTED_FOR_CREWS:
    "Crews don't support this action. Switch to a club or outfitter organization to use it.",
  CATEGORIES_NOT_SUPPORTED_FOR_CREWS:
    "Crews don't use to-do categories. Clear the category and save again.",
  DPA_NOT_ACCEPTED:
    'Accept the current Data Processing Agreement for this organization before importing or emailing customers.',
  CASL_ATTESTATION_REQUIRED:
    'Confirm the CASL consent attestation for this organization before sending to Canadian contacts.',
  signature_request_not_resendable:
    'This signer has already completed signing, so a new invite cannot be sent.',
  upload_template_cannot_be_required:
    "Requested files can't be made required.",
  waiver_requires_membership:
    'A waiver can only be sent to a user in this organization. Use a document for A Specific Person to send it to someone by email.',
  not_supported_for_crews:
    "Crews don't support this action. Switch to a club or outfitter organization to use it.",
  document_too_large: 'That file is larger than 10 MB. Choose a smaller PDF.',
  document_not_pdf: 'That file is not a PDF. Choose a PDF file to file as a signed copy.',
  signed_date_in_future: 'The signed date cannot be in the future.',
  track_not_available_for_filed_request:
    'This document was filed manually and has no e-sign tracking data.',
  INVOICE_AMOUNT_EXCEEDS_BALANCE: (body) => {
    const balance = redactDataDetail(body, 'remainingBalance')
    return balance === null
      ? 'That invoice is more than the remaining balance. Enter a lower amount.'
      : `That invoice is more than the remaining balance of ${balance}. Enter a lower amount.`
  },
}

function redactDataDetail(body: ServerErrorBody, key: string): string | null {
  const data = body.data
  if (data === null || typeof data !== 'object') return null
  const value = (data as Record<string, unknown>)[key]
  if (typeof value === 'number' && Number.isFinite(value)) return String(value)
  if (typeof value !== 'string') return null
  return redactServerMessage(value)
}

export function resolveServerErrorCopy(
  code: string | null | undefined,
  body: ServerErrorBody | null,
): string | null {
  if (!code) return null
  const entry = SERVER_ERROR_COPY[code]
  if (entry === undefined) return null
  return typeof entry === 'string' ? entry : entry(body ?? {})
}
